import type { Random } from '../core/Random';

const SUBJECTS = [
  'Florida Man',
  'Florida Woman',
  'Alabama Grandma',
  'Ohio Man',
  'Area Dad',
  'Local Uncle',
  'Arkansas Man',
  'Kentucky Woman',
  'Panhandle Man',
] as const;

const ACTS = [
  'arrested for riding an alligator',
  'calls 911 because his beer was "too warm"',
  'fights off a black bear with a lawn chair',
  'builds a working hot tub in a truck bed',
  'tries to pay for nachos with a live crawfish',
  'jumps a riding mower over a creek',
  'names all six kids after NASCAR sponsors',
  'attempts to legally marry his bass boat',
  'tries to return a half-eaten rotisserie chicken',
  'found living in a dollar store attic for three weeks',
  'fights a hornet nest with a leaf blower',
  'wins lottery, buys 40 inflatable gorillas',
  'steals 300 pounds of crawfish',
  'crowns himself "King of the Swamp"',
  'gets stuck inside a claw machine',
  'directs traffic in a dinosaur costume',
  'sells "moon rocks" that are just driveway gravel',
  'brings a possum to a job interview',
  'challenges a hurricane to a fist fight',
  'breaks into the zoo to "talk to the flamingos"',
  'drives a golf cart through a car wash',
  'insists his Crocs are "street legal"',
  'opens a lemonade stand that only sells beer',
  'mistakes a manatee for his ex-wife',
] as const;

const TAILS = [
  'in a fast food drive-thru',
  'outside a Waffle House',
  'while wearing Crocs in sport mode',
  'at 3 a.m.',
  'during a church potluck',
  'and says he would "absolutely do it again"',
  'on a riding lawnmower',
  'while yelling "hold my beer"',
  '; police say alcohol "may have been a factor"',
  'in a bait shop parking lot',
  'wearing only a cowboy hat',
  'during a tornado warning',
  'with his mama watching',
] as const;

const NEWS = [
  'WEATHER: 97°F, humidity "yes." Storm Chaser Chet has loosened his tie.',
  'GAS-N-GRUB: Roller dogs 2 for $3 all week. Sushi "fresh-ish."',
  'SHERIFF reminds residents that fireworks are not a home security system.',
  'LOTTERY: Jackpot climbs to $412 million. Local man "feeling it in his bones."',
  'APEX CAPITAL HOLDINGS reports record quarter, thanks residents for their "continued patience."',
  'COUNTY FAIR: Pig races return. Pig declines to comment.',
  'TRAFFIC: Highway 41 backed up behind a riding mower. Again.',
  'SPORTS: Somebody turned left at Talladega. More at 11.',
  'HEALTH: Doctors confirm Mtn Dewd is "technically a liquid."',
  'CRIME: Wind chimes stolen from Lucky Acres. Owner Tammy Lynn "has cameras." She does not.',
  'REAL ESTATE: Private equity buying up mobile home parks; lot rents rise faster than the heat index.',
  'COMMUNITY: Church bake sale raises $340 and one stern warning about Dale.',
  'RODEO: "Widowmaker" remains undefeated. Clown "frankly terrified."',
  'MUD BOG: Fairgrounds report three trucks stuck, one marriage proposal, zero regrets.',
  'COOTER\'S USED CARS: "We tote the note." Customers still unsure what that means.',
  'NIGHTLIFE: Rusty Spur mechanical bull set to "divorce" for ladies night.',
  'BOOZE BARN: Drive-thru now open till 2 AM. County commissioners "looking into it."',
  'GUN RANGE: Gus reports a new record. The record is for cans. Calm down.',
  'LOTTERY: Saturday Mega Bucks drawing at 8. Clerk says buy two, "one for luck."',
] as const;

export function floridaMan(rng: Random): string {
  const subject = rng.pick(SUBJECTS);
  const act = rng.pick(ACTS);
  const tail = rng.pick(TAILS);
  const joiner = tail.startsWith(';') ? '' : ' ';
  return `${subject.toUpperCase()} ${act}${joiner}${tail}`;
}

export function newsBrief(rng: Random): string {
  return rng.pick(NEWS);
}

export function tickerItem(rng: Random): string {
  return rng.chance(0.55) ? `BREAKING: ${floridaMan(rng)}` : newsBrief(rng);
}

/** Headlines about the player's own antics. */
export function localHeadline(
  kind:
    | 'stunt'
    | 'fail'
    | 'jackpot'
    | 'tornado'
    | 'fireworks'
    | 'camaro'
    | 'evicted'
    | 'doublewide'
    | 'catfish'
    | 'still'
    | 'buyback'
    | 'couchfire'
    | 'ufo',
  name: string,
): string {
  const n = name.toUpperCase();
  switch (kind) {
    case 'stunt':
      return `LOCAL: ${n} lands triple backflip on rusty trampoline; video "breaking the internet" (12 views)`;
    case 'fail':
      return `LOCAL: ${n} attempts trampoline stunt, says "worth it" from ambulance-adjacent lawn chair`;
    case 'jackpot':
      return `LOCAL: Lucky Acres resident ${n} wins big on scratch-off, immediately buys more scratch-offs`;
    case 'tornado':
      return `WEATHER: Tornado touches down near Lucky Acres. ${n} seen filming it holding a beer`;
    case 'fireworks':
      return `NOISE COMPLAINT: Fireworks reported at Lucky Acres. Suspect: ${n}. Motive: freedom`;
    case 'couchfire':
      return `FIRE DEPT: Couch "fully engulfed" by BMX field. ${n} says couch "had it coming"`;
    case 'ufo':
      return `UFO?: Lucky Acres resident ${n} reports "lights, a cow, and a very personal exam." Hank "vindicated"`;
    case 'camaro':
      return `AUTOMOTIVE: ${n}'s Camaro leaves cinder blocks for first time since 2009; blocks "feel abandoned"`;
    case 'evicted':
      return `HOUSING: ${n} evicted from Lucky Acres; Apex Capital calls it "unlocking value"`;
    case 'doublewide':
      return `REAL ESTATE: ${n} purchases a DOUBLE WIDE. Park in awe. Darlene "proud, honestly"`;
    case 'catfish':
      return `OUTDOORS: ${n} noodles monster catfish out of Lucky Acres crick; arm "mostly fine"`;
    case 'still':
      return `FIRE DEPT: Mysterious explosion in Lucky Acres' Back Forty. ${n} says it was "a grill thing." Eyebrows missing`;
    case 'buyback':
      return `BUSINESS: Lucky Acres residents buy park back from Apex Capital with a pickle jar of cash. ${n} "not crying, it's pollen"`;
  }
}
